module.exports = __webpack_public_path__ + "media/eyezen-start_bd.05ddda5e.mp4";